var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=splitText.min2.js.map
